(function () {
  'use strict';
  var mobile = window.matchMedia('(max-width: 749px)');
  document.querySelectorAll('[data-responsive-detail]').forEach(function (detail) {
    function resize() { detail.open = !mobile.matches; }
    resize(); mobile.addEventListener('change', resize);
  });
  var track = document.querySelector('.archive-voices');
  var controls = document.querySelector('.archive-review-controls');
  if (!track || !controls) return;
  var slides = Array.from(track.querySelectorAll('.archive-voice'));
  var prev = controls.querySelector('[data-review-prev]');
  var next = controls.querySelector('[data-review-next]');
  var status = controls.querySelector('[data-review-status]');
  var current = 0;
  function update() {
    var left = track.getBoundingClientRect().left;
    current = slides.reduce(function (best, slide, i) {
      return Math.abs(slide.getBoundingClientRect().left - left) < Math.abs(slides[best].getBoundingClientRect().left - left) ? i : best;
    }, 0);
    prev.disabled = current === 0;
    next.disabled = current === slides.length - 1;
    status.textContent = (current + 1) + ' of ' + slides.length;
  }
  function go(delta) {
    var target = slides[Math.max(0, Math.min(slides.length - 1, current + delta))];
    track.scrollBy({left: target.getBoundingClientRect().left - track.getBoundingClientRect().left,
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
  }
  function mode() { controls.hidden = !mobile.matches; track.tabIndex = mobile.matches ? 0 : -1; update(); }
  prev.addEventListener('click', function () { go(-1); });
  next.addEventListener('click', function () { go(1); });
  track.addEventListener('keydown', function (event) {
    if (!mobile.matches || event.target !== track) return;
    if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); go(event.key === 'ArrowRight' ? 1 : -1); }
  });
  track.addEventListener('scroll', update, {passive:true});
  mobile.addEventListener('change', mode);
  mode();
})();
